import _ from "lodash";

export const sortReducer = (state: any, action: any) => {
    switch (action.type) {
        case "CHANGE_SORT":
            if (state.column === action.column) {
                return {
                    ...state,
                    data: state.data.reverse(),
                    direction:
                        state.direction === "ascending"
                            ? "descending"
                            : "ascending",
                };
            }
            return {
                column: action.column,
                data: _.sortBy(state.data, [action.column]),
                direction: "ascending",
            };
        case "SET_DATA":
            return {
                ...state,
                data: action.data,
            };
        default:
            throw new Error();
    }
};
